import React from 'react';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import { ButtonPrimary } from '../../../../../utils/Button';
import InvoiceCancelModal from '../../InvoiceList/Modals/InvoiceCancelModal';
import { useInvoiceInfo } from '../InvoiceInfoProvider';

function InvoiceActionsRow({ invoiceData, noItems }) {
    const { openModal, setConfirm } = useTemplate();
    const { setHeaderLessPrint, handleReload } = useInvoiceInfo();

    const handleCancelInvoice = () => {
        setConfirm({
            showButton: false,
            text: <InvoiceCancelModal data={{ id: invoiceData?.id }} handleReload={handleReload} />
        });
    };
    return (
        <div className="">
            <div className="mb-4 ">
                <h2 className="text-primary text-xl font-normal">Actions</h2>
            </div>

            <div className="flex flex-wrap gap-2">
                {/* If the invoice is a quotation, show the "Convert to Invoice" button */}
                {invoiceData?.isQuotation ? (
                    <ButtonPrimary
                        title="Turn to Invoice"
                        onClick={() => openModal('CONVERT_QUOTATION_TO_INVOICE', invoiceData)}
                        className="normal-case "
                        disabled={
                            invoiceData?.status === 'canceled' ||
                            invoiceData?.authorizedBy > 0 ||
                            invoiceData?.status !== 'due'
                        }
                    />
                ) : null}

                {/* If the invoice is a quotation, show the "Update Quotation No." button */}
                {invoiceData?.isQuotation ? (
                    <ButtonPrimary
                        title="Update Quotation No."
                        onClick={() => openModal('update_quotation_number', invoiceData)}
                        disabled={
                            invoiceData?.status === 'canceled' ||
                            invoiceData?.authorizedBy > 0 ||
                            invoiceData?.status !== 'due'
                        }
                        className="normal-case bg-[#6610f2]"
                    />
                ) : null}

                {/* If the invoice is not a quotation, show the "Update Invoice No." button */}
                {!invoiceData?.isQuotation ? (
                    <ButtonPrimary
                        title="Update Invoice No."
                        onClick={() => openModal('update_invoice_custom_number', invoiceData)}
                        disabled={
                            invoiceData?.status === 'canceled' ||
                            invoiceData?.authorizedBy > 0 ||
                            invoiceData?.status !== 'due'
                        }
                        className="normal-case bg-[#6610f2]"
                    />
                ) : null}

                {/* If the invoice is not a quotation, show the "Update Invoice No." button */}
                {!invoiceData?.isQuotation ? (
                    <ButtonPrimary
                        title="Update Title"
                        onClick={() => openModal('UPDATE_INVOICE_TITLE', invoiceData)}
                        disabled={
                            invoiceData?.status === 'canceled' ||
                            invoiceData?.authorizedBy > 0 ||
                            invoiceData?.status !== 'due'
                        }
                        className="normal-case bg-[#6610f2]"
                    />
                ) : null}
                <ButtonPrimary
                    title="Update Billing Info"
                    onClick={() => openModal('update_invoice_billing_info')}
                    disabled={
                        invoiceData?.status === 'canceled' ||
                        invoiceData?.status !== 'due' ||
                        invoiceData?.authorizedBy > 0
                    }
                    className="bg-warning"
                />

                <ButtonPrimary
                    title={`Update ${invoiceData?.isQuotation ? 'Quotation' : 'Invoice'} Comment`}
                    onClick={() => openModal('update_invoice_note')}
                    disabled={invoiceData?.status === 'canceled' || invoiceData?.authorizedBy > 0}
                    className="bg-[#31d2f2]"
                />
                {invoiceData?.isQuotation ? (
                    <>
                        <ButtonPrimary
                            title="Print with Header"
                            onClick={() => {
                                setHeaderLessPrint(false);
                                setTimeout(() => {
                                    window.print();
                                }, 0);
                            }}
                            disabled={
                                invoiceData?.status === 'canceled' || invoiceData?.status === 'paid'
                            }
                            className="bg-[#0d6efd]"
                        />
                        <ButtonPrimary
                            title="Print without Header"
                            onClick={() => {
                                setHeaderLessPrint(true);
                                setTimeout(() => {
                                    window.print();
                                }, 0);
                            }}
                            disabled={
                                invoiceData?.status === 'canceled' || invoiceData?.status === 'paid'
                            }
                            className="bg-[#6f42c1]"
                        />
                    </>
                ) : (
                    <>
                        <ButtonPrimary
                            title="Print with Header"
                            onClick={() => {
                                setHeaderLessPrint(false);
                                setTimeout(() => {
                                    window.print();
                                }, 0);
                            }}
                            disabled={invoiceData?.status === 'canceled'}
                            // use new color
                            className="bg-[#0d6efd]"
                        />
                        <ButtonPrimary
                            title="Print without Header"
                            onClick={() => {
                                setHeaderLessPrint(true);
                                setTimeout(() => {
                                    window.print();
                                }, 0);
                            }}
                            disabled={invoiceData?.status === 'canceled'}
                            // use different new color
                            className="bg-[#6f42c1]"
                        />
                    </>
                )}

                <ButtonPrimary
                    title="+ Add Service"
                    onClick={() => {
                        openModal('add_new_service_item_to_invoice', invoiceData);
                    }}
                    disabled={
                        invoiceData?.status === 'canceled' ||
                        (!noItems && invoiceData?.status !== 'due') ||
                        invoiceData?.authorizedBy > 0
                    }
                />
                <ButtonPrimary
                    title="Update Payment Info"
                    onClick={() => openModal('UPDATE_INVOICE_PAYMENT_INFO')}
                    disabled={
                        invoiceData?.status === 'canceled' ||
                        invoiceData?.status !== 'due' ||
                        invoiceData?.authorizedBy > 0
                    }
                    className="bg-[#198754]"
                />
                {/* add cancel button */}
                <ButtonPrimary
                    title="Cancel"
                    onClick={handleCancelInvoice}
                    disabled={
                        invoiceData?.status === 'canceled' ||
                        invoiceData?.status === 'paid' ||
                        invoiceData?.authorizedBy > 0
                    }
                    className="bg-error"
                />
            </div>
        </div>
    );
}

export default InvoiceActionsRow;
